import { useEffect } from 'react';
"use strict";
function useHorizontalScroll(ref, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    if (!ref?.current) return;
    const element = ref.current;
    const onWheel = e => {
      if (e.deltaY == 0) return;
      if (element.scrollWidth > element.offsetWidth) {
        e.preventDefault();
        element.scrollBy(e.deltaY, 0);
      }
    };
    element.addEventListener("wheel", onWheel);
    return () => element.removeEventListener("wheel", onWheel);
  }, [enabled, ref]);
}
export { useHorizontalScroll };
//# sourceMappingURL=useHorizontalScroll.mjs.map
